export default __webpack_public_path__ + "static/media/star-eye-emoji.4a4d8a8e.svg";